import { render } from "./SendWhitelistManage.vue?vue&type=template&id=42d2b736&scoped=true"
import script from "./SendWhitelistManage.vue?vue&type=script&lang=js"
export * from "./SendWhitelistManage.vue?vue&type=script&lang=js"

import "./SendWhitelistManage.vue?vue&type=style&index=0&id=42d2b736&scoped=true&lang=scss"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-42d2b736"]])

export default __exports__